module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new03.8db81570.jpg";